import { SELECIONAR_ITINERARIO } from '../types'

export default function selecionarItinerario (itinerario) {
  return {
    type: SELECIONAR_ITINERARIO,
    payload: itinerario
  }
}
